import styled from '@emotion/styled';
import { readableColorIsBlack } from 'color2k';
import { m } from 'framer-motion';
import { cover } from '~/shared/utils/styled';
import { breaks } from '~/theme';
import { getClampFullRange, getClampValue } from '~/theme/utils/getClampValue';

export const StyledList = styled.ul(({ theme }) => ({
    display: 'grid',
    gridAutoFlow: 'column',
    height: '100%',
    gap: getClampValue(breaks.md, breaks.lg, breaks.xl, 0, 8),
    paddingRight: theme.spaces[2],
    marginLeft: `calc(${theme.spaces[3]} * -1)`,
}));

export const StyledDropdown = styled(m.div, {
    shouldForwardProp: (prop: string) => prop !== 'isLightHeader',
})<{ isLightHeader?: boolean }>(({ theme, isLightHeader }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    backgroundColor: !isLightHeader ? theme.traits.background.n21mainMenu : theme.colors.light,
    overflowY: 'hidden',
    // Force behind menu
    zIndex: -1,
}));

export const StyledDropDownContent = styled(m.div)(({ theme: { spacesRaw, gridConfig } }) => ({
    display: 'flex',
    gap: gridConfig.gap,
    padding: `${getClampFullRange(spacesRaw[5], spacesRaw[7])} ${gridConfig.gutter}`,
}));

export const StyledDropDownLine = styled(m.span)(({ theme: { sizes, traits, colors } }) => ({
    position: 'absolute',
    inset: 'auto 0 0',
    height: sizes.borderWidth,
    background: readableColorIsBlack(traits.background.n21mainMenu) ? colors.light30 : colors.dark,
    transformOrigin: 'left',
}));

export const StyledDropDownBackdrop = styled(m.div)(({ theme }) => ({
    ...cover,
    position: 'fixed',
    background: theme.colors.transparentDark,
    cursor: 'pointer',
    zIndex: theme.zIndices['header'] - 1,
}));
